export enum Permission {
  VIEW_DASHBOARD = '7f4a1e2b',
  VIEW_MESSAGES = '1c9b4d7a',
  VIEW_MY_ACTIVITIES = 'a8e23c91',
  START_EVALUATION = 'd3f19b7c',
  VIEW_EVALUATIONS = '4b92e8ad',
  START_ASSESSMENT = 'e1a9c3f4',
  VIEW_ASSESSMENTS = '9d3b5e72',
  VIEW_TRAINING_CANDIDATES = '2a7e5f9b',
  VIEW_CHARITY_PROFILE = 'a1b2c3d4',
  VIEW_TRAININGS = 'c8d4e3a6',
  VIEW_ABOUT_AFRA = 'b7c9f412',
  VIEW_AFRA_STANDARD = '53d1a8ef',
  VIEW_AFRA_CALENDAR = '8f2e9b35',
  VIEW_AFRA_FEEDBACK = '0da4c7b8',
  VIEW_PRE_ASSESSMENTS = '6c7a4b1d',
}
